import { PopoverPlacement } from "@idui/react-popover";
import { CircularProgress, IconButton } from "@mui/material";
import { FC } from "react";
import { useTranslation } from "react-i18next";

import { SVG_MUI } from "@ryde/assets";

import { AccessControl, FramerTooltip } from "../../../common";

interface IDropdownBoundFindAreaButtonProps {
  isFindingArea: boolean;
  handleFindArea: () => Promise<void>;
}

export const DropdownBoundFindAreaButton: FC<
  IDropdownBoundFindAreaButtonProps
> = ({ isFindingArea, handleFindArea }) => {
  const { t } = useTranslation();
  return (
    <div className="find-area-button-container">
      <AccessControl entity="station" action="update">
        <FramerTooltip
          content={t("station.FIND_AREA")}
          placement={PopoverPlacement.top}
        >
          <IconButton
            onClick={handleFindArea}
            disabled={isFindingArea}
            aria-label={t("station.FIND_AREA")}
          >
            {isFindingArea ? (
              <CircularProgress size={20} />
            ) : (
              <SVG_MUI.MenuMapSVG aria-hidden="true" />
            )}
          </IconButton>
        </FramerTooltip>
      </AccessControl>
    </div>
  );
};
